import React, { useState, useEffect } from 'react';
import './Instructions.css';

const Instructions = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState('');
  const [showError, setShowError] = useState(false);

  const correctPassword = 'ludmila2024';

  const handlePasswordSubmit = (e) => {
    e.preventDefault();
    if (password === correctPassword) {
      setIsAuthenticated(true);
      setShowError(false);
    } else {
      setShowError(true);
      setPassword('');
    }
  };

  useEffect(() => {
    document.title = 'Инструкции по SEO - Людмила Фисенко';
  }, []);

  if (!isAuthenticated) {
    return (
      <div className="password-overlay">
        <div className="password-prompt">
          <h2>🔒 Доступ ограничен</h2>
          <p>Введите пароль для просмотра инструкций:</p>
          <form onSubmit={handlePasswordSubmit}>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Пароль"
              className="password-input"
              autoFocus
            />
            <button type="submit" className="password-button">
              Войти
            </button>
          </form>
          {showError && <p className="error-message">Неверный пароль</p>}
        </div>
      </div>
    );
  }

  return (
    <div className="instructions-container">
      <div className="instructions-header">
        <h1>🎯 Инструкции по SEO-продвижению</h1>
        <p>Пошаговое руководство для Людмилы Фисенко</p>
      </div>

      <div className="instructions-content">
        <a href="/" className="back-link">← Вернуться на главную</a>

        <div className="toc">
          <h3>📋 Содержание</h3>
          <ul>
            <li><a href="#google-business">1. Google Business Profile</a></li>
            <li><a href="#photos">2. Фотографии</a></li>
            <li><a href="#posts">3. Публикации</a></li>
            <li><a href="#reviews">4. Отзывы</a></li>
            <li><a href="#social">5. Социальные сети</a></li>
            <li><a href="#directories">6. Каталоги</a></li>
            <li><a href="#analytics">7. Аналитика</a></li>
            <li><a href="#content-plan">8. Контент-план</a></li>
            <li><a href="#weekly-tasks">9. Еженедельные задачи</a></li>
            <li><a href="#results">10. Ожидаемые результаты</a></li>
          </ul>
        </div>

        <h2 id="google-business">🏢 1. Google Business Profile (Приоритет #1)</h2>

        <div className="step-box">
          <h4>Шаг 1: Создание профиля</h4>
          <ol>
            <li>Перейдите на сайт: <strong>https://business.google.com</strong></li>
            <li>Нажмите <strong>"Управлять сейчас"</strong></li>
            <li>Введите название: <strong>"Людмила Фисенко - Психолог"</strong></li>
            <li>Выберите категорию: <strong>"Психолог"</strong> (основная) + <strong>"Служба психического здоровья"</strong> (дополнительная)</li>
          </ol>
        </div>

        <div className="step-box">
          <h4>Шаг 2: Заполнение информации</h4>
          <ul>
            <li><strong>Название:</strong> Людмила Фисенко - Психолог</li>
            <li><strong>Адрес:</strong> Ваш рабочий адрес в Праге</li>
            <li><strong>Телефон:</strong> +420 607 882 680</li>
            <li><strong>Веб-сайт:</strong> https://milafisenko.com</li>
          </ul>
        </div>

        <div className="example-text">
          <strong>Описание для Google Business (до 750 символов):</strong><br/><br/>
          Опытный психолог и гештальт-терапевт в Праге с более чем 10-летним опытом. 
          Индивидуальная и семейная терапия на украинском и русском языках. 
          Сертифицированный специалист EAGT. Работа с травмой, тревожностью, 
          семейными кризисами. Онлайн и офлайн консультации. Помощь в адаптации 
          для эмигрантов. Запись по телефону или через сайт.
        </div>

        <div className="checklist">
          <h4>Услуги для добавления:</h4>
          <ul>
            <li>Индивидуальная психотерапия</li>
            <li>Семейная терапия</li>
            <li>Парная терапия</li>
            <li>Гештальт-терапия</li>
            <li>Работа с травмой</li>
            <li>Консультации онлайн</li>
            <li>Психологическая помощь эмигрантам</li>
            <li>Кризисная терапия</li>
          </ul>
        </div>

        <h2 id="photos">📸 2. Фотографии для Google Business</h2>

        <div className="step-box">
          <h4>Что нужно загрузить:</h4>
          <ol>
            <li><strong>Фото профиля</strong> - ваше профессиональное фото</li>
            <li><strong>Фото офиса</strong> - если принимаете клиентов в офисе</li>
            <li><strong>Логотип</strong> - роза или ваш логотип</li>
            <li><strong>Фото рабочего места</strong> - кабинет, кресла для терапии</li>
            <li><strong>Диплом/Сертификаты</strong> - ваш реальный диплом психолога</li>
          </ol>
        </div>

        <div className="photo-downloads">
          <h4>📥 Готовые фотографии для загрузки:</h4>
          <div className="photo-grid">
            <div className="photo-item">
              <h5>👤 Фото профиля (720x720)</h5>
              <a href="/images/google-business/profile-photo-720x720.jpg" download="ludmila-profile-720x720.jpg" className="download-btn">
                Скачать минимальное качество
              </a>
              <a href="/images/google-business/profile-photo-1080x1080.jpg" download="ludmila-profile-1080x1080.jpg" className="download-btn">
                Скачать высокое качество
              </a>
            </div>
            
            <div className="photo-item">
              <h5>🏢 Фото офиса/рабочего места</h5>
              <a href="/images/google-business/office-workspace-photo.jpg" download="ludmila-office-workspace.jpg" className="download-btn">
                Скачать фото офиса
              </a>
            </div>
            
            <div className="photo-item">
              <h5>🌹 Логотип</h5>
              <a href="/images/google-business/logo-720x720.png" download="ludmila-logo-720x720.png" className="download-btn">
                Скачать логотип PNG
              </a>
            </div>
            
            <div className="photo-item">
              <h5>📜 Диплом/Сертификат</h5>
              <a href="/images/google-business/diploma-certificate.jpg" download="ludmila-diploma-certificate.jpg" className="download-btn">
                Скачать диплом
              </a>
              <p className="photo-note">✅ Реальный диплом Людмилы</p>
            </div>
            
            <div className="photo-item">
              <h5>👩‍⚕️ Дополнительное фото</h5>
              <a href="/images/google-business/professional-photo.jpg" download="ludmila-professional.jpg" className="download-btn">
                Скачать проф. фото
              </a>
            </div>
          </div>
        </div>

        <div className="warning">
          <strong>Требования к фото:</strong><br/>
          • Размер: минимум 720x720 пикселей<br/>
          • Формат: JPG или PNG<br/>
          • Качество: высокое разрешение<br/>
          • Количество: минимум 3-5 фотографий
        </div>

        <div className="step-box">
          <h4>📤 Как загрузить фотографии в Google Business:</h4>
          <ol>
            <li>Откройте <strong>Google Business Profile</strong></li>
            <li>Перейдите в раздел <strong>"Фотографии"</strong></li>
            <li>Нажмите <strong>"Добавить фотографии"</strong></li>
            <li>Выберите категорию:
              <ul>
                <li><strong>Логотип</strong> - загрузите логотип с розой</li>
                <li><strong>Фото профиля</strong> - ваше профессиональное фото</li>
                <li><strong>Дополнительные</strong> - офис, диплом, рабочее место</li>
              </ul>
            </li>
            <li>Загрузите скачанные выше файлы</li>
            <li>Добавьте описания к каждому фото</li>
          </ol>
        </div>

        <div className="success">
          <h4>✅ Рекомендуемые описания для фотографий:</h4>
          <ul>
            <li><strong>Профиль:</strong> "Людмила Фисенко - психолог и гештальт-терапевт в Праге"</li>
            <li><strong>Офис:</strong> "Кабинет для психологических консультаций в Праге"</li>
            <li><strong>Логотип:</strong> "Людмила Фисенко - психологическая помощь"</li>
            <li><strong>Диплом:</strong> "Диплом психолога Людмилы Фисенко - профессиональная квалификация"</li>
          </ul>
        </div>

        <h2 id="posts">📝 3. Регулярные публикации (1-2 раза в неделю)</h2>

        <div className="example-text">
          <strong>Пример поста - Совет:</strong><br/><br/>
          🧠 Совет психолога: "Когда чувствуете тревогу, попробуйте технику 5-4-3-2-1"<br/>
          Назовите:<br/>
          • 5 вещей, которые видите<br/>
          • 4 вещи, которые слышите<br/>
          • 3 вещи, которые можете потрогать<br/>
          • 2 запаха<br/>
          • 1 вкус<br/><br/>
          Это поможет вернуться в настоящий момент.<br/>
          Записаться на консультацию: +420 607 882 680
        </div>

        <div className="example-text">
          <strong>Пример поста - Услуга:</strong><br/><br/>
          💑 Парная терапия в Праге<br/>
          Помогаю парам:<br/>
          • Улучшить общение<br/>
          • Преодолеть кризисы<br/>
          • Восстановить доверие<br/>
          • Найти компромиссы<br/><br/>
          Консультации на украинском и русском языках.<br/>
          Онлайн и офлайн формат.
        </div>

        <h2 id="reviews">⭐ 4. Получение отзывов</h2>

        <div className="example-text">
          <strong>Шаблон сообщения клиентам:</strong><br/><br/>
          Здравствуйте! Надеюсь, наша работа была полезной для вас. 
          Если вы довольны результатом, буду очень благодарна за отзыв 
          в Google. Это поможет другим людям найти психологическую помощь.<br/><br/>
          Ссылка на отзыв: [ваша ссылка Google Business]<br/><br/>
          Спасибо за доверие!<br/>
          Людмила
        </div>

        <div className="step-box">
          <h4>Когда просить отзывы:</h4>
          <ul>
            <li>После успешного завершения терапии</li>
            <li>После 5-6 сессий, если виден прогресс</li>
            <li>У клиентов, которые выражают благодарность</li>
          </ul>
        </div>

        <h2 id="results">📈 10. Ожидаемые результаты</h2>

        <div className="success">
          <h4>Через 1 месяц:</h4>
          <ul>
            <li>✅ Настроенный Google Business Profile</li>
            <li>✅ 5-10 первых отзывов</li>
            <li>✅ Регистрация в основных каталогах</li>
            <li>✅ Настроенная аналитика</li>
          </ul>
        </div>

        <div className="success">
          <h4>Через 3 месяца:</h4>
          <ul>
            <li>✅ 20+ отзывов в Google</li>
            <li>✅ Топ-10 по запросу "психолог Прага"</li>
            <li>✅ Увеличение звонков на 50%</li>
            <li>✅ Стабильный поток новых клиентов</li>
          </ul>
        </div>

        <div className="success">
          <h4>Через 6 месяцев:</h4>
          <ul>
            <li>✅ Топ-3 по основным запросам</li>
            <li>✅ 50+ отзывов</li>
            <li>✅ Узнаваемость бренда в сообществе</li>
            <li>✅ Постоянный поток клиентов без рекламы</li>
          </ul>
        </div>

        <div className="warning">
          <h4>🚨 Важные моменты - что НЕЛЬЗЯ делать:</h4>
          <ul>
            <li>❌ Покупать фальшивые отзывы</li>
            <li>❌ Использовать одинаковые тексты везде</li>
            <li>❌ Игнорировать негативные отзывы</li>
            <li>❌ Публиковать личную информацию клиентов</li>
            <li>❌ Давать медицинские советы в постах</li>
          </ul>
        </div>

        <div className="success">
          <h4>✅ Что ОБЯЗАТЕЛЬНО делать:</h4>
          <ul>
            <li>✅ Отвечать на все отзывы и сообщения</li>
            <li>✅ Регулярно обновлять информацию</li>
            <li>✅ Соблюдать этику психолога в постах</li>
            <li>✅ Указывать контакты во всех публикациях</li>
            <li>✅ Мониторить упоминания в интернете</li>
          </ul>
        </div>

        <div className="timeline">
          <h4>💡 Для быстрого старта:</h4>
          <ol>
            <li><strong>Сначала</strong> настройте Google Business Profile</li>
            <li><strong>Затем</strong> попросите отзывы у текущих клиентов</li>
            <li><strong>После</strong> регистрируйтесь в каталогах</li>
            <li><strong>В последнюю очередь</strong> развивайте соцсети</li>
          </ol>
        </div>

        <div className="instructions-header" style={{marginTop: '3rem'}}>
          <h3>🌹 Удачи в продвижении!</h3>
          <p>Ваша экспертиза заслуживает того, чтобы о ней знали все, кто нуждается в психологической помощи в Праге!</p>
        </div>

        <a href="/" className="back-link">← Вернуться на главную</a>
      </div>
    </div>
  );
};

export default Instructions;
